//#region src/nodey-graph-templates/image-gen.ts
var e = (e) => ({
	options: {},
	connections: [{
		inputNodeId: "a406d1da-94e3-4203-b558-418adf2d19f6",
		outputNodeId: "302ccfbc-b56b-4077-84a2-27b33abb4497",
		inputName: "prompt",
		outputName: "text_data",
		isEnabled: !0,
		type: "string"
	}, {
		inputNodeId: "0466b3ad-c6dc-4d1a-8990-d6fdae4b6901",
		outputNodeId: "a406d1da-94e3-4203-b558-418adf2d19f6",
		inputName: "image_data",
		outputName: "generated_image",
		isEnabled: !0,
		type: "image"
	}],
	frames: [],
	nodes: {
		"0466b3ad-c6dc-4d1a-8990-d6fdae4b6901": {
			id: "0466b3ad-c6dc-4d1a-8990-d6fdae4b6901",
			type: "io-image-asset-save",
			customName: "Save OKO Image Asset",
			position: {
				x: 683.0422478502946,
				y: 311.3171573228496
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"302ccfbc-b56b-4077-84a2-27b33abb4497": {
			id: "302ccfbc-b56b-4077-84a2-27b33abb4497",
			type: "const-string",
			customName: "Text",
			position: {
				x: -5.99999999999996,
				y: 235.99999999999997
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"a406d1da-94e3-4203-b558-418adf2d19f6": {
			id: "a406d1da-94e3-4203-b558-418adf2d19f6",
			type: "gemini-flash2-5-image",
			customName: "Gemini Flash2.5 Image",
			position: {
				x: 312.1877078861457,
				y: 259.9546740883782
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		}
	}
});
//#endregion
export { e as imageGenNodeyTemplate };
